//@vendor
const get = require('lodash/object/get');
//@constants
const actionTypes = require('constants/actionTypes');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');
const { API_ENTERPRISE_NUMBER,
        API_CENTER,
        FIRST_STEP,
        CARD_MODIFY_LIMIT_APPROVED_MESSAGE,
        CARD_MODIFY_LIMIT_PENDING_MESSAGE,
        CARD_MODIFY_LIMIT_REJECTED_MESSAGE,
        CARD_MODIFY_LIMIT_SERVICE_ERROR_MESSAGE,
        CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE } = require('constants/index');
//@utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { nonNumericFilter } = require('utilities/stringHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');

const OPERATION_SUCCED = 'OK';
const requestIncreaseLimitInProgress = () => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_INCREASE_REQUEST
    };
};

const requestIncreaseLimitFailure = (error, errorType) => {
    const action = {
        type: actionTypes.CARD_MODIFY_LIMIT_INCREASE_FAILURE,
        payload: {
            error,
            serviceErrorMessage: ''
        }
    };

    switch (errorType) {
        case CARD_MODIFY_LIMIT_REJECTED_MESSAGE:
            action.payload.operationStatus = CARD_MODIFY_LIMIT_REJECTED_MESSAGE;
            break;
        case CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE:
            const errorMessage = get(error, 'result.detalleErrorList.detalleErrorList[0].error.descripcion', '') || '';
            const errorCode = get(error, 'result.detalleErrorList.detalleErrorList[0].error.codigo', '') || '';
            action.payload.errorCode = errorCode;
            action.payload.operationStatus = CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE;
            action.payload.operationErrorMessage = errorMessage;
            break;
        case CARD_MODIFY_LIMIT_SERVICE_ERROR_MESSAGE:
        default:
            action.payload.operationStatus = CARD_MODIFY_LIMIT_SERVICE_ERROR_MESSAGE;
    }

    return action;
};

const requestIncreaseLimitSuccess = (response, message) => {
    const action = {
        type: actionTypes.CARD_MODIFY_LIMIT_INCREASE_SUCCESS,
        payload: {
            response,
            operationStatus: message
        }
    };

    if (message === CARD_MODIFY_LIMIT_APPROVED_MESSAGE) {
        action.payload.approvedAmount = get(response, 'limiteConcedido', 0) || 0;
    } else {
        action.payload.approvedAmount = 0;
    }

    return action;
};


const requestIncreaseLimit = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immCardModifyLimit = getState().cardModifyLimit;
        const immStepOne = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
        const immCardReference = immCardModifyLimit.getIn(['increaseLimits','cardReferenceData']);
        const currentLimit = immStepOne.get('currentLimit');
        const contractNumber = immCard.getIn(['contract', 'number']);
        const cardContract = `${API_ENTERPRISE_NUMBER}${API_CENTER}${immCard.getIn(['contract', 'product'])}${contractNumber}`;
        const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        

        const params = {
            header: {
                version: 2,
            },
            query: {
                contratoTarjeta: cardContract,
                cuentaCargo: nonNumericFilter(immCard.get('associatedAccount')),
                firma: {
                    dataToken
                },
                limiteActual: currentLimit,
                limiteSolicitado: immStepOne.get('tentativeLimit'),
                pan: nonNumericFilter(immCard.get('number')),
                tarjetaRef: {
                    canal: immCardReference.get('channel'),
                    standard: immCard.getIn(['criteria', 'c1', 'estand']),
                    subtipo: immCard.get('productSubType'),
                    tipo: immCard.get('newProduct')
                }
            }
        };

        dispatch(requestIncreaseLimitInProgress());
        return APIPost({dispatch, endpoint: 'cardIncreaseLimit', params})
            .then(response => {
                const operationStatus = get(response, 'result.msg');
                if (operationStatus === OPERATION_SUCCED){
                    const operationId = get(response, 'estado.id');
                    switch (operationId){
                        case '0':
                        case '1':
                        case '2':
                        case '3':
                        case '4':
                        case '5':
                        case '6':
                            const message = ['0', '1', '2'].includes(operationId) ? CARD_MODIFY_LIMIT_PENDING_MESSAGE : CARD_MODIFY_LIMIT_APPROVED_MESSAGE;
                            dispatch(requestIncreaseLimitSuccess(response, message));
                            if (showIneAndRevolving) {
                                const termsAndsCondsHiringData = [
                                    {
                                        standard: immCard.getIn(['product', 'standard']),
                                        subType: immCard.getIn(['product', 'subtype']),
                                        type: immCard.getIn(['product', 'type'])
                                    }
                                ];
                                dispatch(setTermsAndCondsInfoRevolving(immCard.get('standarAlias'), termsAndsCondsHiringData, contractNumber));
                            }
                            break;
                        case '7':
                        case '8':
                        case '9':
                            return dispatch(requestIncreaseLimitFailure(response, CARD_MODIFY_LIMIT_REJECTED_MESSAGE));
                    }
                } else {
                    return dispatch(requestIncreaseLimitFailure(response, CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE));
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestIncreaseLimitFailure(response, CARD_MODIFY_LIMIT_SERVICE_ERROR_MESSAGE));
                } else {
                    throw response;
                }
            });
    };

    new Promise(() => signaturePatternActions.validateAndExecute(dispatch, getState, callback));
};

module.exports = { requestIncreaseLimit };
